import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import WalletPage from './WalletPage';

export default flowRight(withVerificationGuard, withAuthGuard())(WalletPage);
